var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AdminProductList',{attrs:{"data":_vm.products,"product-name":"lashus","product-code":"lh"},on:{"on-deleted-item":_vm.fetchLh}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }